/**
 * Fetcher Order
 * @author Tevin
 */

import { Fetcher } from '@components/bases/Fetcher';
import MenuPathTree from '@fetchers/datas/MenuPathTree';

export class FOrder extends Fetcher {
    constructor() {
        super({
            urlPrefix: ['/api/order/', '/Home/Order/'],
            mockPath: MenuPathTree.projectName,
        });
    }

    // 获取订单统计数据（订单统计）
    getOrderStatistic(search) {
        const url = this.spellURL('getOrderStatistic', '../../lpg/admin/Order/orderStatistic');
        const send = {
            ...search,
            datetime: search.date?.replace(',', ' - '),
        };
        delete send.date;
        return this.post(url, send);
    }

    // 获取订单单天统计分析数据（今日订单）
    getOrderStatisticOnDay(search) {
        const url = this.spellURL('getOrderStatisticOnDay', '../../lpg/admin/Order/todayOrder');
        const send = {
            ...this.transKeyName('underline', search),
            type: 1,
        };
        return this.post(url, send);
    }

    // 获取订单列表（订单列表）
    getOrderList(search, pagination, sorter, abortHandler) {
        const url = this.spellURL('getOrderList', '../../lpg/admin/Order/orderList');
        const send = {
            ...this.transKeyName('underline', search),
            tradeNo: search.tradeNo,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: {
                money: 'money',
                voucher: 'voucher',
                status: 'status',
                createtime: 'createtime',
                okTime: 'ok_time',
                judgeBottle: 'judge_bottle',
                judgeService: 'judge_service',
                deliveryTime: 'delivery_time',
                shopname: 'store',
                reducePrice: 'reduce_price',
                truepay: 'truepay',
            }[sorter.field],
            sortOrder: sorter.order,
        };
        if (search.tradeNo) {
            send.tradeNo = search.tradeNo;
        }
        delete send['trade_no'];
        return this.post(url, send, {
            remap: [
                ['', 'count', 'total'],
                ['', 'orders', 'rows'],
            ],
            abortHandler,
        });
    }

    // 保存订单列表导出（订单列表）
    saveOrderListExport(search) {
        const url = this.spellURL('saveOrderListExport', '../../lpg/admin/Order/export_order');
        const send = {
            ...this.transKeyName('underline', search),
            user_name: search.name,
        };
        return this.post(url, send);
    }

    // 获取订单指派信息（订单列表）
    getOrderAppointInfo(search) {
        const url = this.spellURL(
            'getOrderAppointInfo',
            '../../lpg/admin/Order/appointOrderInfo',
        );
        const send = {
            id: search.ordernum,
        };
        return this.post(url, send);
    }

    // 保存订单指派（订单列表）
    saveOrderAppoint(appoint) {
        const url = this.spellURL('saveOrderAppoint', '../../lpg/admin/Order/appointOrder');
        const send = {
            ...this.transKeyName('underline', appoint),
        };
        return this.post(url, send);
    }

    // 保存设置订单门店（订单列表）
    saveOrderStore(store) {
        const url = this.spellURL('saveOrderStore', '../../lpg/admin/Order/setOrderStore');
        const send = {
            ...this.transKeyName('underline', store),
        };
        return this.post(url, send);
    }

    // 保存订单转派门店（订单列表）
    saveOrderModifyStore(store) {
        const url = this.spellURL('saveOrderModifyStore', '../../lpg/admin/Order/transferStore');
        const send = {
            ...this.transKeyName('underline', store),
        };
        return this.post(url, send);
    }

    // 保存推送到安拓系统（推送安拓）
    saveOrderPushToAnTuo(data) {
        const url = this.spellURL('saveOrderPushToAnTuo', 'atPushOneOrder');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取订单详情（订单列表-订单详情）
    getOrderDetail(order) {
        const url = this.spellURL('getOrderDetail', '../../lpg/admin/Order/orderDetail');
        const send = {
            ...order,
        };
        return this.post(url, send);
    }

    // 获取订单优惠券（订单列表-订单详情）
    getOrderCoupons(order) {
        const url = this.spellURL('getOrderCoupons', '../../lpg/admin/Order/orderDetailVoucher');
        const send = {
            ...order,
        };
        return this.post(url, send);
    }

    // 保存取消订单（订单列表-订单详情）
    saveOrderCancel(cancel) {
        const url = this.spellURL('saveOrderCancel', 'update_order_detail');
        const send = {
            ...this.transKeyName('underline', cancel),
        };
        return this.post(url, send);
    }

    // 获取订单调价信息（订单列表-订单详情）
    getOrderAdjustInfo(order) {
        const url = this.spellURL('getOrderAdjustInfo', '../../lpg/admin/Order/reducePriceInfo');
        const send = {
            ...order,
        };
        return this.post(url, send);
    }

    // 保存订单调价（订单列表-订单详情）
    saveOrderAdjustPrice(modify) {
        const url = this.spellURL('saveOrderAdjustPrice', '../../lpg/admin/Order/reducePrice');
        const send = {
            ...modify,
            op_note: modify.opNote,
        };
        delete send.opNote;
        return this.post(url, send);
    }

    // 保存订单退款（订单列表-订单详情）
    saveOrderRefund(refund) {
        const url = this.spellURL('saveOrderRefund', '../../lpg/admin/Order/returnGoods');
        const send = {
            ...refund,
        };
        return this.post(url, send);
    }

    // 保存订单备注（订单列表-订单详情）
    saveOrderNote(note) {
        const url = this.spellURL('saveOrderNote', '../../lpg/admin/Order/updateNote');
        const send = {
            ...this.transKeyName('underline', note),
        };
        return this.post(url, send);
    }

    // 保存订单预约时间（订单列表-订单详情）
    saveOrderDeliveryTime(newTime) {
        const url = this.spellURL('saveOrderDeliveryTime', '../../lpg/admin/Order/modifyDeliveryTime');
        const send = {
            ...this.transKeyName('underline', newTime),
        };
        return this.post(url, send);
    }

    // 获取订单气瓶使用费（订单详情）
    getOrderUseFee(order) {
        const url = this.spellURL('getOrderUseFee', '../../lpg/admin/Order/orderUseDetail');
        const send = {
            ...order,
        };
        return this.post(url, send);
    }

    // 获取微信支付状态（订单列表-订单详情）
    getOrderWxPayStatus(order) {
        const url = this.spellURL('getOrderWxPayStatus', '../../lpg/admin/Order/wxpayCheck');
        const send = {
            ...order,
        };
        return this.post(url, send);
    }

    // 获取退款订单列表（退款订单）
    getOrderRefundList(search, pagination, sorter) {
        const url = this.spellURL('getOrderRefundList', '../../lpg/admin/Order/refundList');
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 保存退款订单审核（退款订单）
    saveRefundOrderCheck(refund) {
        const url = this.spellURL('saveRefundOrderCheck', '../../lpg/admin/Order/approveRefund');
        const send = {
            ...this.transKeyName('underline', refund),
        };
        return this.post(url, send);
    }

    // 保存退款订单退款（退款订单）
    saveRefundOrderRefund(refuse) {
        const url = this.spellURL('saveRefundOrderRefund', '../../lpg/admin/Order/confirmRefund');
        const send = {
            ...this.transKeyName('underline', refuse),
        };
        return this.post(url, send);
    }

    // 保存退款订单退款（退款订单）
    saveRefundOrderRefuse(refund) {
        const url = this.spellURL('saveRefundOrderRefuse', 'refuse_order');
        const send = {
            ...this.transKeyName('underline', refund),
        };
        return this.post(url, send);
    }

    // 退款订单不退款（退款订单）
    saveRefundNoRefund(refund) {
        const url = this.spellURL('saveRefundNoRefund', '../../lpg/admin/Order/refuseRefund');
        const send = {
            ...this.transKeyName('underline', refund),
        };
        return this.post(url, send);
    }

    // 获取调价订单列表（调价订单）
    getAdjustPriceOrderList(search, pagination, sorter) {
        const url = this.spellURL('getAdjustPriceOrderList', '../../lpg/admin/Order/voucherOrderList');
        const send = {
            ...search,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            date: search.date?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取临时费用订单列表（临时费用订单）
    getExtraPriceOrder(search, pagination, sorter) {
        const url = this.spellURL('getExtraPriceOrder', '../../lpg/admin/Order/extraPriceList');
        const send = {
            ...search,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 保存临时费用审核（临时费用订单）
    saveExtraPriceExamine(examine) {
        const url = this.spellURL('saveExtraPriceExamine', '../../lpg/admin/Order/auditExtraPrice');
        const send = {
            ...this.transKeyName('underline', examine),
        };
        return this.post(url, send);
    }

    // 获取会员订单历史（添加订单）
    getUserOrder(search) {
        const url = this.spellURL('getUserOrder', '../../lpg/admin/Order/userOrder');
        const send = {
            ...search,
            user_id: search.userId,
        };
        return this.post(url, send, {
            remap: [
                ['rows.[]', 'createtime', 'createTime'],
                ['rows.[]', 'uid', 'uId'],
            ],
        });
    }

    // 获取会员支付可用优惠券列表（添加订单）
    getUserCoupons(search) {
        const url = this.spellURL('getUserCoupons', '../../lpg/admin/Order/orderVoucher');
        const send = {
            ...search,
            user_id: search.userId,
            floor_fee: search.floorFee,
        };
        return this.post(url, send);
    }

    // 获取维修工单列表（报修工单）
    getRepairOrderList(search, pagination, sorter) {
        const url = this.spellURL('getRepairOrderList', '../../lpg/admin/repairorder/repairList');
        const send = {
            ...search,
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            datetime: search.datetime?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取报修工单详情（报修工单）
    getRepairOrderDetail(repair) {
        const url = this.spellURL('getRepairOrderDetail', '../../lpg/admin/repairorder/repairDetail');
        const send = {
            ...this.transKeyName('underline', repair),
        };
        return this.post(url, send);
    }

    // 保存报修工单指派（报修工单）
    saveRepairAppoint(appoint) {
        const url = this.spellURL('saveRepairAppoint', '../../lpg/admin/repairorder/appointRepair');
        const send = {
            ...this.transKeyName('underline', appoint),
        };
        return this.post(url, send);
    }

    // 保存报修工单取消（报修工单-详情）
    saveRepairCancel(cancel) {
        const url = this.spellURL('saveRepairCancel', '../../lpg/admin/repairorder/cancelRepair');
        const send = {
            ...this.transKeyName('underline', cancel),
        };
        return this.post(url, send);
    }

    // 保存报修工单备注（报修工单-详情）
    saveRepairNote(note) {
        const url = this.spellURL('saveRepairNote', '../../lpg/admin/repairorder/updateRepair');
        const send = {
            ...this.transKeyName('underline', note),
        };
        return this.post(url, send);
    }

    // 获取补瓶工单列表（补瓶工单）
    getReplenishOrderList(search, pagination, sorter) {
        const url = this.spellURL(
            'getReplenishOrderList',
            '../../lpg/admin/WorkOrder/ReplenishList',
        );
        const send = {
            ...this.transKeyName('underline', search),
            page_num: pagination.current,
            page_size: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取补瓶工单-导出地址（补瓶工单）
    getReplenishOrderExportUrl(search) {
        const url = this.spellURL('../common/defaultExportUrl', 'export_replenish.html');
        const send = {
            ...search,
        };
        if (Fetcher.inDevMod) {
            return this.post(url, send).then(res => ({ url: res.file }));
        } else {
            return this.get(url, send, { timeout: 300 * 1000 }).then(res => {
                if (!res) {
                    return null;
                }
                let url2 = this.spellURL('', '../Index/downloadExport');
                return {
                    url: this.parseParamUrl(url2, { filename: res.file || res.data }),
                };
            });
        }
    }

    // 获取补瓶工单详情（补瓶工单）
    getReplenishOrderDetail(order) {
        const url = this.spellURL(
            'getReplenishOrderDetail',
            '../../lpg/admin/WorkOrder/ReplenishDetail',
        );
        const send = {
            ...order,
        };
        return this.post(url, send);
    }

    // 获取补瓶工单指派信息（补瓶工单）
    getReplenishAppointInfo(appoint) {
        const url = this.spellURL(
            'getReplenishAppointInfo',
            '../../lpg/admin/WorkOrder/appointReplenishInfo',
        );
        const send = {
            ...appoint,
        };
        return this.post(url, send);
    }

    // 保存补瓶工单指派（补瓶工单）
    saveReplenishJobAppoint(appoint) {
        const url = this.spellURL(
            'saveReplenishJobAppoint',
            '../../lpg/admin/WorkOrder/appointReplenish',
        );
        const send = {
            ...this.transKeyName('underline', appoint),
        };
        return this.post(url, send);
    }

    // 保存异步导出补瓶工单（补瓶工单）
    saveExportReplenishJobAppoint(search) {
        const url = this.spellURL('saveExportReplenishJobAppoint', 'exportReplenishList');
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 保存会员换瓶单（添加订单）
    saveBottleOrder(orderInfo) {
        const url = this.spellURL('saveBottleOrder', '../../lpg/admin/Order/addPhoneOrder');
        const send = {
            ...orderInfo,
            user_id: orderInfo.userId,
            dispatch_uid: orderInfo.dispatchUid,
            delivery_time: orderInfo.deliveryTime,
            bottle_use_ids: orderInfo.bottleUseIds,
            pay: {
                ...orderInfo.pay,
                floor_fee: orderInfo.pay.floorFee,
                far_fee: orderInfo.pay.farFee,
                discount_money: orderInfo.pay.discountMoney,
                vouchers: orderInfo.pay.vouchers.map(voucher => ({
                    ...voucher,
                    product_id: voucher.productId,
                })),
                suppress_zero: orderInfo.pay.suppressZero,
            },
            products: orderInfo.products.map(product => ({
                ...product,
                singleDeposit: product.money,
            })),
        };
        delete send.userId;
        delete send.dispatchUid;
        delete send.deliveryTime;
        delete send.pay.discountMoney;
        delete send.bottleUseIds;
        delete send.pay.floorFee;
        delete send.pay.farFee;
        delete send.pay.suppressZero;
        send.pay.vouchers.forEach(voucher => {
            delete voucher.productId;
        });
        return this.post(url, send);
    }

    // 保存会员报修单 （添加订单）
    saveRepairOrder(orderInfo) {
        const url = this.spellURL('saveRepairOrder', '../../lpg/admin/repairorder/addRepairOrder');
        const send = {
            ...this.transKeyName('underline', orderInfo),
        };
        return this.post(url, send);
    }

    // 保存客诉（添加订单）
    saveComplaint(complaintInfo) {
        const url = this.spellURL('saveComplaint', '../../lpg/admin/complaint/addComplaint');
        const send = {
            ...this.transKeyName('underline', complaintInfo),
        };
        return this.post(url, send);
    }

    // 获取客诉列表（客诉列表）
    getComplaintList(search, pagination) {
        const url = this.spellURL('getComplaintList', '../../lpg/admin/complaint/getComplaintList');
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                pageNum: pagination.current,
                pageSize: pagination.pageSize,
                date: search.date?.replace(',', ' - '),
            }),
        };
        return this.post(url, send);
    }

    // 获取客诉详情（客诉列表）
    getComplaintDetail(id) {
        const url = this.spellURL(
            'getComplaintDetail',
            '../../lpg/admin/complaint/getComplaintDetail',
        );
        const send = {
            id,
        };
        return this.post(url, send);
    }

    // 更新客诉状态（客诉列表）
    saveComplaintStatus(data) {
        const url = this.spellURL(
            'saveComplaintStatus',
            '../../lpg/admin/complaint/updateComplaintStatus',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 导出客诉列表（客诉列表）
    saveComplaintListExport(search) {
        const url = this.spellURL(
            'saveComplaintListExport',
            '../../lpg/admin/complaint/exportComplaintList',
        );
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                date: search.date?.replace(',', ' - '),
            }),
        };
        return this.post(url, send);
    }

    // 获取维修项列表（维修项列表）
    getRepairItemList(search, pagination, sorter) {
        const url = this.spellURL(
            'getRepairItemList',
            '../../lpg/admin/repairorder/getRepairItemList',
        );
        const send = {
            ...this.transKeyName('underline', {
                ...search,
                pageNum: pagination.current,
                pageSize: pagination.pageSize,
            }),
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 保存维修项（维修项列表）
    saveEditRepairItem(item) {
        const url = this.spellURL(
            'saveEditRepairItem',
            '../../lpg/admin/repairorder/saveRepairItem',
        );
        const send = {
            ...this.transKeyName('underline', item),
        };
        return this.post(url, send);
    }

    // 删除维修项（维修项列表）
    saveDelRepairItem(item) {
        const url = this.spellURL(
            'saveDelRepairItem',
            '../../lpg/admin/repairorder/deleteRepairItem',
        );
        const send = {
            ...this.transKeyName('underline', item),
        };
        return this.post(url, send);
    }

    // 获取维修项列表 - 筛选项（添加订单）
    getRepairItemOptions() {
        const url = this.spellURL(
            'getRepairItemOptions',
            '../../lpg/admin/repairorder/getRepairItemOptions',
        );
        return this.post(url, {});
    }

    // 获取维修统计列表（维修统计汇总）
    getRepairStatisticsList(search, sorter) {
        const url = this.spellURL(
            'getRepairStatisticsList',
            '../../lpg/admin/repairorder/getRepairSummary',
        );
        const send = {
            ...this.transKeyName('underline', search),
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取维修统计详情（维修统计汇总）
    getRepairStatisticsDetail(data) {
        const url = this.spellURL(
            'getRepairStatisticsDetail',
            '../../lpg/admin/repairorder/getRepairItemDetail',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 催单（订单列表）
    saveOrderReminder(data) {
        const url = this.spellURL('saveOrderReminder', '../../lpg/admin/Order/pushOrder');
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取订单放空申请列表（订单放空申请）
    getOrderEmptyApplicationList(search, pagination, sorter) {
        const url = this.spellURL(
            'getOrderEmptyApplicationList',
            '../../lpg/admin/Order/getZoneApplyList',
        );
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 保存订单放空审核（订单放空申请）
    saveOrderEmptyApplication(data) {
        const url = this.spellURL(
            'saveOrderEmptyApplication',
            '../../lpg/admin/Order/approveZoneApply',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 保存补瓶工单取消（补瓶工单）
    saveReplenishCancel(data) {
        const url = this.spellURL(
            'saveReplenishCancel',
            '../../lpg/admin/WorkOrder/cancelReplenish',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取退残订单列表（退残订单）
    getResidualOrderList(search, pagination) {
        const url = this.spellURL(
            'getResidualOrderList',
            '../../lpg/admin/Order/residualOrderList',
        );
        const send = {
            ...this.transKeyName('underline', search),
            datetime: search.datetime?.replace(',', ' - '),
            page: pagination.current,
            limit: pagination.pageSize,
        };
        return this.post(url, send);
    }

    // 保存退残订单导出（退残订单）
    saveExportResidualOrder(search) {
        const url = this.spellURL(
            'saveExportResidualOrder',
            '../../lpg/admin/Order/export_residualOrder',
        );
        const send = {
            ...this.transKeyName('underline', search),
            datetime: search.datetime?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取退残订单导出结果（退残订单）
    getExportResidualOrderResult(data) {
        const url = this.spellURL(
            'getExportResidualOrderResult',
            '../../lpg/admin/getExportResult',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }
}

export const $fetchOrder = new FOrder();
